module.exports = __webpack_public_path__ + "images/bannerES-063f6f74115e8e0fc3a265ee3742ca43.png";